import AbstractDataAttributeBehaviour from "./abstract-data-attribute-behaviour";
import EventManager from "../services/event-manager";

export default class PreventDoubleSubmitBehaviour extends AbstractDataAttributeBehaviour {

    attrNames = {
        container: 'data-prevent-double-submit'
    };

    constructor() {
        super();
        this.eventManager = new EventManager();
        this.eventManager.createEvent('form:unlock', 'Form unlock requested');
    }

    getContainerSelector = () => `[${this.attrNames.container}]`;

    initContainer = (form) => {
        let submitting= false;

        // Lock on submit
        form.addEventListener('submit', (event) => {
            if (submitting) {
                event.preventDefault();
                return;
            }

            submitting = true;
            this.disableButtons(true, form);

        });

        this.eventManager.subscribe('form:unlock', () => {
            if (!submitting) return;
            submitting = false;
            this.disableButtons(false, form);
        });

        const unlockOnInput = () => {
            if (!submitting) return;
            this.eventManager.triggerEvent('form:unlock');
        };

        form.querySelectorAll('input, select, textarea').forEach(field => {
            field.addEventListener('input', unlockOnInput);
            field.addEventListener('keyup', unlockOnInput);
            field.addEventListener('change', unlockOnInput);
        });
    };

    disableButtons(disabled, form) {
        form.querySelectorAll('button[type="submit"], input[type="submit"]')
            .forEach(button => button.disabled = disabled);
    }
}